export const employeeMovementSchema = {
  position_id: {
    type: String,
    required: false,
  },
  company_id: {
    type: String,
    required: false,
  },
  lob_id: {
    type: String,
    required: false,
  },
  department_id: {
    type: String,
    required: false,
  },
  division_id: {
    type: String,
    required: false,
  },
  team_id: {
    type: String,
    required: false,
  },
  level: {
    type: String,
    required: false,
  },
  remark: {
    type: String,
    required: false,
  },
  module: {
    type: String,
    required: false,
  },
  start_date: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: false,
  },
  name: {
    type: String,
    required: true,
  },
}

export const filterMovement = values => {
  const _values = { ...values }
  Object.keys(values).map(key => {
    if (!employeeMovementSchema[key]) {
      delete _values[key]
      return key
    } else if (_values[key] === null) {
      _values[key] = ''
    }
    return key
  })
  return _values
}




// WEBPACK FOOTER //
// ./src/components/new-employee/schema/movement-schema.js